export default "__VITE_ASSET__DHEpPvXo__"